export default __webpack_public_path__ + "static/media/ProfileIcon.740b70d5.svg";